// درس‌های پشتیبانی‌دار اعلام‌شده (پکیج «از کلمه تا مکالمه»)، هم‌خوان با پنل دانشجو و استاد؛
// needSupport بکند روی پکیج‌های بزرگ‌تر (مثل «تمام دروس فرمن») هم خورده و فعلا ملاک نیست
export const SUPPORT_LESSON_IDS = [
  10040, 10041, 10042, 10043, 10044, 10045, 10046, 10047, 10048, 10057,
  10058, 10059, 10060, 10061, 10063, 10066, 10067, 10074, 10099, 10103,
];

// پکیجی که همه‌ی درس‌هایش جزو درس‌های بالاست
export function packageNeedsSupport(lessonCategory) {
  const lessons = (lessonCategory && lessonCategory.lessonCategoryLessons) || [];
  return lessons.length > 0 && lessons.every((lesson) => SUPPORT_LESSON_IDS.includes(Number(lesson.lessonId)));
}
